// Pure nutrition-totals helper.
//
// Consumes a catalog (meals with database nutrition values) and a
// selection map { [etm_id]: quantity } and returns the summed daily
// totals.  No hardcoded fallback values.  A meal missing a nutrient
// value contributes 0 for that nutrient — never a guessed number.

export function computeSelectionTotals(meals, selection) {
  const totals = { calories: 0, protein_g: 0, carbs_g: 0, fat_g: 0 };
  if (!Array.isArray(meals) || !selection) return totals;
  const byEtm = new Map();
  for (const m of meals) byEtm.set(m.etm_id, m);
  for (const [etm_id, rawQty] of Object.entries(selection)) {
    const qty = Number(rawQty);
    if (!Number.isFinite(qty) || qty <= 0) continue;
    const m = byEtm.get(etm_id);
    if (!m) continue;
    const cal = Number(m.calories);
    const p = Number(m.protein_g);
    const c = Number(m.carbs_g);
    const f = Number(m.fat_g);
    if (Number.isFinite(cal)) totals.calories += cal * qty;
    if (Number.isFinite(p)) totals.protein_g += p * qty;
    if (Number.isFinite(c)) totals.carbs_g += c * qty;
    if (Number.isFinite(f)) totals.fat_g += f * qty;
  }
  return totals;
}
